import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import i18next from "i18next";
import { I18nextProvider, initReactI18next } from "react-i18next";
import global_es from './Translations/es/global.json';
import global_en from './Translations/en/global.json';
import global_pt from './Translations/pt/global.json';
import App from "./App";
import { Provider } from 'react-redux';
import { persister, store } from './app/store';
import { PersistGate } from 'redux-persist/integration/react';

i18next.use(initReactI18next).init({
  compatibilityJSON: 'v3',
  lng: 'es',
  fallbackLng: 'en',
  resources: {
    es: {
      global: global_es
    },
    en: {
      global: global_en
    },
    pt: {
      global: global_pt
    }
  },
  interpolation: {
    escapeValue: false
  },
  react: {
    useSuspense: false,
  }
});

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

root.render(
  //<React.StrictMode>
    <I18nextProvider i18n={i18next}>
      <BrowserRouter basename={process.env.PUBLIC_URL}>
        <Provider store={store}>
          <PersistGate loading={null} persistor={persister}>
            <App />
          </PersistGate>
        </Provider>
      </BrowserRouter>
    </I18nextProvider>
  //</React.StrictMode>,
);
